import { ApolloError, useMutation } from '@apollo/client';
import { graphql } from '../gql';
import { useMemo } from 'react';

const DELETE_EXCESS_TOWER_LAYER_PARTICIPANT_MUTATION = graphql(`
  mutation deleteExcessTowerLayerParticipant(
    $position: Int!
    $quoteUuid: String!
    $participantUuid: String!
  ) {
    deleteParticipant(
      position: $position
      quoteUuid: $quoteUuid
      participantUuid: $participantUuid
    ) {
      result
      relationshipsDeleted
      nodesDeleted
      description
    }
  }
`);

export function useDeleteExcessTowerLayerParticipant() {
  const [deleteExcessTowerLayerParticipant, { data, loading, error, reset }] =
    useMutation(DELETE_EXCESS_TOWER_LAYER_PARTICIPANT_MUTATION, {});

  const result = data?.deleteParticipant?.result;

  // TODO: Remove this when https://convergeins.atlassian.net/browse/CON-3242 is fixed
  const newError = useMemo((): Error | void => {
    if (error) {
      return error;
    }

    if (result === 'FAIL') {
      return new ApolloError({
        errorMessage:
          'Failed to delete excess tower layer participant. Does it exist?',
      });
    }
  }, [result, error]);

  return {
    data,
    deleteExcessTowerLayerParticipant: async (
      ...args: Parameters<typeof deleteExcessTowerLayerParticipant>
    ) => {
      const response = await deleteExcessTowerLayerParticipant(...args);

      if (response.data?.deleteParticipant.result === 'FAIL') {
        throw new ApolloError({
          errorMessage:
            'Failed to delete excess tower layer participant. Does it exist?',
        });
      }

      return response;
    },
    loading,
    error: newError,
    reset,
  };
}
